/* eslint-disable formatjs/no-literal-string-in-jsx */
import { FC } from 'react';
import { z } from 'zod';
import { useModalContext } from './ModalContext';
import { Stack } from '@mui/material';

const testModalSchema = z.object({
	id: z.string(),
});

const TestModal: FC<z.infer<typeof testModalSchema>> = ({ id }) => {
	const { closeModal } = useModalContext();

	return (
		<Stack>
			{id}
			<button onClick={() => closeModal()}>zavrit</button>
		</Stack>
	);
};

export { TestModal, testModalSchema };
